export default{
    dialog: {
        buttonOk: 'OK',
        buttonCancel: 'Cancel',
    },
    photoBrowser:{
        bannerPhotoBrowser:'Close'
    },
    productAddedToCartSuccess: "商品已加入購物車"
}